module.exports = __webpack_public_path__ + "img/logo20.3910e0c8.jpg";